import { useEffect } from 'react';
import styleUrl from '../../assets/2018/css/style.css?url';
import styleZhUrl from '../../assets/2018/css/style_zh.css?url';
import styleAwardsUrl from '../../assets/2018/css/style_awards.css?url';
import styleAwardsZhUrl from '../../assets/2018/css/style_awards_zh.css?url';
import animateUrl from '../../assets/2018/css/animate.css?url';
import jqueryUrl from '../../assets/2018/js/jquery-3.2.1.min.js?url';
import customUrl from '../../assets/2018/js/custom.js?url';
import scrollaUrl from '../../assets/2018/js/scrolla.jquery.min.js?url';
import colorboxUrl from '../../assets/2018/js/jquery.colorbox-min.js?url';

const FONT_AWESOME_URL = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css';
const POPPINS_URL = 'https://fonts.googleapis.com/css?family=Poppins:400,700';

const loadScript = (src: string, key: string) =>
  new Promise<void>((resolve, reject) => {
    const existing = document.querySelector(`script[data-year-2018-script="${key}"]`) as HTMLScriptElement | null;
    if (existing) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.setAttribute('data-year-2018-script', key);
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.body.appendChild(script);
  });

export const use2018Assets = (opts: { lang: 'en' | 'zh'; title: string; variant?: 'home' | 'awards' }) => {
  const { lang, title, variant = 'home' } = opts;

  useEffect(() => {
    document.title = title;

    const prevBodyClass = document.body.className;
    const prevBodyId = document.body.id;
    document.body.className = variant === 'home' ? 'body homepage responsive3' : 'body';
    document.body.id = 'body';

    const links: HTMLLinkElement[] = [];
    const styles =
      variant === 'awards'
        ? lang === 'zh'
          ? [styleAwardsUrl, styleAwardsZhUrl, animateUrl]
          : [styleAwardsUrl, animateUrl]
        : lang === 'zh'
          ? [styleUrl, styleZhUrl, animateUrl]
          : [styleUrl, animateUrl];
    const externalStyles = [POPPINS_URL, FONT_AWESOME_URL];

    [...styles, ...externalStyles].forEach((href) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.setAttribute('data-year-2018-style', 'true');
      document.head.appendChild(link);
      links.push(link);
    });

    (async () => {
      try {
        await loadScript(jqueryUrl, 'jquery');
        await loadScript(colorboxUrl, 'colorbox');
        await loadScript(scrollaUrl, 'scrolla');
        await loadScript(customUrl, 'custom');
      } catch {
        // Keep page render resilient even if a legacy script fails to load.
      }
    })();

    return () => {
      links.forEach((l) => l.remove());
      document.querySelectorAll('script[data-year-2018-script]').forEach((s) => s.remove());
      document.body.className = prevBodyClass;
      document.body.id = prevBodyId;
    };
  }, [lang, title, variant]);
};

